export default __webpack_public_path__ + "static/media/wege.b73e8f0f.svg";